/**
 * Created by DSadler on 12/04/2017.
 */
import Homepage from './Homepage';

export default Homepage;


// WEBPACK FOOTER //
// ./src/App/Homepage/index.js